import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { generateActivityFilters } from '../../utils';

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var FILTERS_TO_TRANSFORM__UPPERCASE = ['products', 'eventTypes', 'objectTypes'];
var KEYS_TO_TRANSFROM = new Map([['actors', 'accountIds']]);
export var generateActivityFiltersV2 = function generateActivityFiltersV2() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return generateActivityFilters(filters, function (originalkey, originalFilter) {
    var filter = Array.isArray(originalFilter) && FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map(function (f) {
      return f.toUpperCase();
    }) : originalFilter;
    var key = KEYS_TO_TRANSFROM.has(originalkey) ? KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
    return _defineProperty({}, key, filter);
  });
};